import { getRelicActionName, RELIC_ACTION_TYPES_NAME, addRelicAnalyticsPageAction, getRelicUserType, getRelicGeolocation, getRelicRegisteredCountry, } from '@nike/privacy-shared-logic';
const gpcTrack = async () => {
    var _a;
    try {
        if (!((_a = window.webShellClient) === null || _a === void 0 ? void 0 : _a.identity)) {
            throw new Error('web shell identity does not exist');
        }
        const { getIsLoggedIn } = window.webShellClient.identity;
        const gpcValue = navigator.globalPrivacyControl;
        const isLoggedIn = await getIsLoggedIn();
        const relicName = getRelicActionName(RELIC_ACTION_TYPES_NAME.GPC_ENABLED);
        const relicOptions = {
            geolocation: getRelicGeolocation(),
            user_type: getRelicUserType(isLoggedIn),
            gpc: gpcValue,
        };
        if (isLoggedIn) {
            addRelicAnalyticsPageAction(relicName, {
                ...relicOptions,
                registered_country: await getRelicRegisteredCountry(isLoggedIn),
            });
            return;
        }
        addRelicAnalyticsPageAction(relicName, relicOptions);
    }
    catch (error) {
        return;
    }
};
if (!window.__gpcTrackInjected) {
    const pageShowHandler = (event) => {
        if (!event.persisted) {
            gpcTrack();
        }
    };
    window.addEventListener('pageshow', pageShowHandler);
    window.addEventListener('pagehide', event => {
        if (!event.persisted) {
            window.removeEventListener('pageshow', pageShowHandler);
            window.__gpcTrackInjected = false;
        }
    });
    window.__gpcTrackInjected = true;
}
